import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";

import { map } from "rxjs/operators";

// env
import { environment } from "environments/environment";

// model
import { User } from "@models/CommonModel";

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private baseUrl = environment.apiUrl + "/api/v1/";
  public token: any = localStorage.getItem("token");

  constructor(private http: HttpClient) { }

 

  ActivateUser(id) {
    return this.http.get<any>(this.baseUrl + "users/" + id + "/activate");
  }


  update(updateUser: User) {
    let url = this.baseUrl + "users/" + updateUser.userId;
    var formData2: any = new FormData();
    formData2.append("fullName", updateUser.fullName);
    formData2.append("userType", updateUser.userType);
    formData2.append("gender", updateUser.gender);
    formData2.append("email", updateUser.email);
    formData2.append("status", updateUser.status);
    formData2.append("file", updateUser.file);
    formData2.append("desiredScore", updateUser.desiredScore);
    formData2.append("package", updateUser.package);

    formData2.append("mobilePhone", updateUser.mobilePhone);
    if (updateUser.branch != "") {
      formData2.append("branch", updateUser.branch);
    }

    return this.http.put(url, formData2);
  }
  register(user: User, isGuest?: boolean) {
    let url = "";

    var formData: any = new FormData();
    if (isGuest) {
      url = this.baseUrl + "users/signup?isGuest=true";
      formData.append("fullName", user.fullName);
      formData.append("mobilePhone", user.mobilePhone);

      formData.append("email", user.email);
      formData.append("gender", user.gender);
    } else {
      url = this.baseUrl + "users/signup";
      formData.append("fullName", user.fullName);
      formData.append("userType", user.userType);
      formData.append("gender", user.gender);
      formData.append("email", user.email);
      formData.append("password", user.password);
      formData.append("status", user.status);
      formData.append("desiredScore", user.desiredScore);
      formData.append("package", user.package);
      formData.append("mobilePhone", user.mobilePhone);
    }

    if (user.branch != "") {
      formData.append("branch", user.branch);
    }
    if (user.file != "") {
      formData.append("file", user.file);
    }
    return this.http.post(url, formData);
  }

  deleteUser(id) {

    return this.http
      .delete<any>(this.baseUrl + "users/" + id)
      .pipe(map((obj) => obj || {}));
  }


  login(obj) {
    return this.http.post<any>(this.baseUrl + "users/login", obj).pipe(map((obj) => obj || {}));
  }
  // users//

 

}
